import { gql } from '@apollo/client';

/**
 * The options a member should be shown, in display order. Every field is
 * requested together because the CTAs need the practical support data as soon
 * as an option is picked.
 */
export const ONBOARDING_SUPPORT_OPTIONS_QUERY = gql`
  query OnboardingSupportOptions {
    onboardingSupportOptions {
      options
      practicalSupport {
        helpService {
          id
          icon
        }
        bookableServiceSlug
      }
    }
  }
`;
